import { render, staticRenderFns } from "shared/modules/seo/seo-text.html?vue&type=template&id=3c5f3288&"
import script from "./SeoTextContent.vue?vue&type=script&lang=js&"
export * from "./SeoTextContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports